export const ProjectDetailsMutations = {
  DeleteProjectValidationErrorKeySuccess: 'deleteProjectValidationErrorKeySuccess',
  DeleteEventTypeValidationErrorKeySuccess: 'deleteEventTypeValidationErrorKeySuccess',
  FetchProjectAttachmentsSuccess: 'fetchProjectAttachmentsSuccess',
  SetIsSavingProject: 'setIsSavingProject',
  SetProject: 'setProject',
  SetProjectDetailsLoading: 'setProjectDetailsLoading',
  SetProjectClientContactsSortOrder: 'setProjectClientContactsSortOrder',
  SetProjectTESContactsSortOrder: 'setProjectTESContactsSortOrder',
  SetProjectEventTypesSortOrder: 'setProjectEventTypesSortOrder',
  SetProjectPurchaseOrdersSortOrder: 'setProjectPurchaseOrdersSortOrder',
  SetProjectTravelRatesSortOrder: 'setProjectTravelRatesSortOrder',
  SetProjectTechniciansSortOrder: 'setProjectTechniciansSortOrder',
  SetProjectValidationErrorsSuccess: 'setProjectValidationErrorsSuccess',
  SetEventTypeValidationErrorsSuccess: 'setEventTypeValidationErrorsSuccess',
  SortProjectClientContacts: 'sortProjectClientContacts',
  SortProjectTESContacts: 'sortProjectTESContacts',
  SortProjectTechnicians: 'sortProjectTechnicians',
  SortProjectEventTypes: 'sortProjectEventTypes',
  SortProjectPurchaseOrders: 'sortProjectPurchaseOrders',
  SortProjectTravelRates: 'sortProjectTravelRates'
};

export const ProjectDetailsActions = {
  CreateEventType: 'createEventType',
  DeleteProjectValidationErrorKey: 'deleteProjectValidationErrorKey',
  FetchProject: 'fetchProject',
  FetchProjectAttachments: 'fetchProjectAttachments',
  SaveProject: 'saveProject',
  SetProjectClientContactsSortOrder: 'setProjectClientContactsSortOrder',
  SetProjectTESContactsSortOrder: 'setProjectTESContactsSortOrder',
  SetProjectEventTypesSortOrder: 'setProjectEventTypesSortOrder',
  SetProjectPurchaseOrdersSortOrder: 'setProjectPurchaseOrdersSortOrder',
  SetProjectTravelRatesSortOrder: 'setProjectTravelRatesSortOrder',
  SetProjectTechniciansSortOrder: 'setProjectTechniciansSortOrder',
  SetProjectValidationErrors: 'setProjectValidationErrors',
  SaveProjectClientContact: 'saveProjectClientContact',
  SaveProjectTesContact: 'saveProjectTesContact'
};

export const ProjectDetailsGetters = {
  CurrentProject: 'CurrentProject',
  CurrentProjectAttachments: 'CurrentProjectAttachments',
  IsProjectAttachmentsLoading: 'IsProjectAttachmentsLoading',
  IsProjectDetailsLoading: 'IsProjectDetailsLoading',
  IsSavingProject: 'IsSavingProject',
  ProjectClientContactsSortOrder: 'ProjectClientContactsSortOrder',
  ProjectTESContactsSortOrder: 'ProjectTESContactsSortOrder',
  ProjectEventTypesSortOrder: 'ProjectEventTypesSortOrder',
  ProjectPurchaseOrdersSortOrder: 'ProjectPurchaseOrdersSortOrder',
  ProjectTravelRatesSortOrder: 'ProjectTravelRatesSortOrder',
  ProjectTechniciansSortOrder: 'ProjectTechniciansSortOrder',
  ProjectValidationErrors: 'ProjectValidationErrors',
  EventTypeValidationErrors: 'EventTypeValidationErrors'
};
